<template>
  <div class="bg-white">
    <div class="bg-headers">
    </div>
    <v-row>
      <v-col cols="12">
        <v-row class="d-flex justify-center align-center">
          <v-col cols="11">
            <h3 class="font-weight-medium blue-grey--text text--lighten-2 text-center">
              Vive la experiencia de tu profesión con nuestros recorridos por el campus donde conocerás:
              <br>
              - Nuestras aulas y áreas comunes <br>
              - Laboratorios <br>
              - Simuladores especializados 
              <br>
              <br>
              Además, tendrás la oportunidad de platicar con profesionales experimentados en su campo laboral
            </h3>           
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn
              class="px-12 button-vizcaya primary--text animated"
              rounded
              large
              color="white"
              @click="scrollToContact()"
              >Agenda tu cita</v-btn
            >                  
          </v-col>
        </v-row>
      </v-col>
    </v-row>     
    <v-row class="py-12">
      <v-col cols="12">
        <v-row class="d-flex justify-center align-center">
          <v-col cols="12">
            <div class="pa-3 d-flex justify-center align-center" style="background-color: #313131;">
              <h3 class="white--text text-center">
                Inscribirte con antelación tiene sus beneficios, por eso en esta ocasión contarás con:
              </h3>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class=" color-uva mb-0" height="20vh">
            <v-img
              src="/imagenes/descubre-2022/50-inscrip.png"
              :height="$vuetify.breakpoint.mdAndUp ? '35vh':'10vh'"
            ></v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <Contact bgClass="white pt-12 pb-6" id="contact"/>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
      <v-btn color="white" dark text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>
<style scoped>
.bg-headers{
  background-image: url("/descubre/header.png");
  height: 120vh;
  background-size: cover;
  background-position: center;
}
.bg-footers{
  background-image: url("/descubre/footer.png");
  background-size: cover;
  background-color: #f3f3f3
}
.div-footer{
  padding-top: 30%;
}
.middle{
  justify-content: center;
  align-items: center;
  display: flex;
}
.bg-white{
  background-color: white !important;
}
.redonded{
  border-radius: 0px 17rem 0px 0px;
}
.button-vizcaya {
  box-shadow: 0 0rem 1rem #cd385099;
}
@media (max-width: 780px) {
  .div-footer{
    padding-top: 60%;
  }
  .redonded{
    border-radius: 0px 5rem 0px 0px;
  }
  .hidden-xxs{
    display: none !important;
  }
  .bg-headers{
    background-image: url("/descubre/movil.png");
    height: 120vh;
    background-size: cover;
    background-position: center;
  }
}
@media (min-width: 1440px) {
  .text-title{
    font-size: 4rem;
  }  
  .text-subtitle{
    font-size: 1.5rem;
  }  
  .text-p{
    font-size: 1.5rem;
  }
}
</style>
<script>
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import axios from "axios";
import Contact from "../components/Contact.vue";
export default {
  directives: {
    mask
  },
  components: {
    Contact,
  },  
  mounted() {
    let countDownDate = new Date("Nov 20, 2020 00:00:00").getTime();
    let self = this;
    // Update the count down every 1 second
    let x = setInterval(function() {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="demo"
      self.days = days;
      self.hours = hours;
      self.minutes = minutes;
      self.seconds = seconds;

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
      }
    }, 1000);
  },
  data: () => ({
    snackbar:false,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    snackbarColor:'info',
    snackbarText:'',
    fromlink: null,
    isLoading: false,
    publicPath: process.env.BASE_URL,
    campusSelected: "",
    offsetTop: 0,
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
      horarios: "",
      localidad: "",
      message: "Me interesa toda la información sobre Descubre Vizcaya",
      licenciatura: false,
      posgrado: false,
      otros: false,
      preescolar: false,
      primaria: false,
      secundaria: false,
      preparatoria: false,
      escolaridad: "",
      school: "",
      way: ""
    },
  }),
  computed: {
    ...mapState({
      campus: state => state.cities.campus,
      campus_all: state => state.cities.campus,
      city_options: state => state.cities.city_options,
      city_selected: state => state.cities.city_selected,
      cities: state => state.cities.cities,
      vida: state => state.cities.vida,
      link_location: state => state.cities.link_location,
      link_information: state => state.cities.link_information
    }),
    marginTop(){
      if(this.$vuetify.breakpoint.mdAndUp){
        return "-15vh";
      }else{
        "-10vh";
      }
    }
  },  
  methods:{
    scrollToContact() {
      document.getElementById("contact").scrollIntoView();
    },
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },
    validateFields() {
      if (
        this.information.name_first != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.campusSelected != "" &&
        this.information.localidad != "" &&
        this.information.message != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText = "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        this.snackbarColor = "dark";
      }
    },
    submit() {
      this.information.escolaridad = "";
      let escola = false
      if (this.information.preescolar) {
        escola = true;
      }        
      if (this.information.primaria) {
        escola = true;
      }        
      if (this.information.secundaria) {
        escola = true;
      }
      if (this.information.preparatoria) {
        escola = true;
      }
      if(!escola){
        this.snackbarText = "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        return;
      }
      this.validateFields();
      if (this.valid) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      if (this.valid && this.emailValid && this.phoneValid) {
        if (this.information.preescolar) {
          this.information.escolaridad += "Primaria ";
        }        
        if (this.information.primaria) {
          this.information.escolaridad += "Preescolar ";
        }        
        if (this.information.secundaria) {
          this.information.escolaridad += "Secundaria ";
        }
        if (this.information.preparatoria) {
          this.information.escolaridad += "Preparatoria ";
        }
        this.sendInfoData();
      }
    },
    sendInfoData() {
      let self = this;
      self.isLoading = true;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("phone", this.information.phone);
      formData.append("municipality", this.information.localidad);
      formData.append("campus", this.campusSelected);
      formData.append("message", this.information.message);
      formData.append("carreer", "Descubre Vizcaya");
      formData.append("subject", "Descubre Vizcaya - Informes");
      formData.append("information_by_level", this.information.escolaridad);
      formData.append("procedence", "Descubre Vizcaya");
      formData.append("comunication", "Descubre Vizcaya");
      formData.append("webpage", "Colegio");
      axios({
        method: "post",
        url: "https://informesuva.tidingo.com/api/create-information",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
          }
        }
      })
        .then(function(response) {
          if (response.data.status == 200) {
            self.snackbarText =
              "Información enviada, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.snackbar = true;
            self.clearFields();
          } else {
            self.snackbarText =
              "Ocurrio un error al enviar tu información, intentalo mas tarde";
            self.snackbarColor = "error";
            self.snackbar = true;
            self.clearFields();
          }
          self.isLoading = false;
        })
        .catch(function(error) {
          self.isLoading = false;
        });
    },
    clearFields(){
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        phone: "",
        email: "",
        campus: "",
        carrer: "",
        horarios: "",
        localidad: "",
        message: "Me interesa toda la información sobre Descubre Vizcaya",
        licenciatura: false,
        posgrado: false,
        otros: false,
        escolaridad: "",
        school: "",
        way: ""
      }
    },
    onScroll(e) {
      this.offsetTop = window.scrollY;
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  }
};
</script>